// Maps record/formData into a request for pp upsert endpoint
export const mapUpsert = (record, formData, selectedSchedule) => {
  if (!record || !formData) return {};

  const posSettingsRecord = record.store_settings.pos_settings[0];
  const posSettingsFormData = formData.store_settings.pos_settings[0];

  const posType = formData.pos_type_id;
  const posTypeSettingsKey = `${getPosType(posType)}_settings`;
  const otherPosTypesKeys = getOtherPosTypes(posType)
    .map(posType => `${posType}_settings`);

  let upsertBody = {
    'id': record.id, 
    'password': formData.password,
    'old_password': record.password,
    'pos_type_id': formData.pos_type_id,
    'pos_settings': {
      'pos_type_id': formData.pos_type_id,
      'deleted_flag': record.deleted_flag,
      'enabled': record.enabled,
      'parsingError': posSettingsRecord.parsingError,
      'participant_id': posSettingsFormData.participant_id,
      'pos_file_access_id': posSettingsFormData.pos_file_access_id,
      'store_id': record.id
    },
    'onpoint_participating': formData.onpoint_participating,
    'old_onpoint_participating': record.onpoint_participating,
    'schedule': selectedSchedule === '__new__' ? new Date().toISOString() : selectedSchedule
  }

  // Inject pos settings and blank fields
  const requiredFields = PosSettingsFields
    .find(fields => fields.id === posType).defaultValues;

  let trimmedFormData = {};
  Object.keys(requiredFields)
    .forEach(field => trimmedFormData[field] = posSettingsFormData[field]);
  
  upsertBody.pos_settings[posTypeSettingsKey] = trimmedFormData;
  for (let typeKey of otherPosTypesKeys) {
    upsertBody.pos_settings[typeKey] = null;
  }

  return upsertBody;
}

// Parses record's stringified pos settings into an object
// Handles Python-formatted strings (True, False, None, single quotes)
export const parsePosSettings = (raw_settings) => {
  if (!raw_settings) return null;

  try {
    const jsonString = raw_settings
      .replace(/\\/g, '\\\\')
      .replace(/'/g, '"')
      .replace(/\bTrue\b/g, 'true')
      .replace(/\bFalse\b/g, 'false')
      .replace(/\bNone\b/g, 'null');
    return JSON.parse(jsonString);
  }
  catch(err) {
    console.error('error parsing POS settings: ', err);
    return undefined;
  }
}

// Extracts the relevant settings object from parsed pos_settings based on pos_type_id
export const getSettingsForPosType = (parsedSettings, posTypeId) => {
  if (!parsedSettings || !posTypeId) return {};
  const posType = PosSettingsFields.find(t => t.id === Number(posTypeId));
  if (!posType) return {};
  const key = `${posType.name}_settings`;
  return parsedSettings[key] ?? {};
}

const getPosType = (id) => PosSettingsFields
  .filter(typeObj => typeObj.id === id)[0].name;

const getOtherPosTypes = (id) => PosSettingsFields
  .filter(typeObj => typeObj.id !== id && typeObj.id !== 0)
  .map(typeObj => typeObj.name);

export const PosSettingsFields = [
  {
    id: 0,
    name: 'none',
    label: 'None',
    defaultValues: {}
  },
  {
    id: 1,
    name: 'passport',
    label: '1 - Passport',
    defaultValues: {
      "source_path": "\\\\10.5.48.2\\",
      "passport_domain": "Posserver01",
      "passport_username": "BackOffice",
      "passport_password": "BackOffice",
      "ftp_connection_type": 2,
      "ftp_host": "\\\\10.5.60.1\\",
      "ftp_port": 21,
      "ftp_password": "L00k4MyD@ta",
      "ftp_username": "PPXMLData",
      "days_to_keep": 31
    }
  },
  {
    id: 2,
    name: 'commander',
    label: '2 - Commander',
    defaultValues: {
      "days_to_keep": 100,
      "password_length": 8,
      "reset_password_interval": 28,
      "CommanderIP": "192.168.31.11",
      "CommanderUser": "iconnect",
      "CommanderPass": "A123456",
      "LastUpdateDate": "0001-01-01T00:00:00"
    }
  },
  {
    id: 5,
    name: 'smartdesq',
    label: '5 - SmartDesq',
    defaultValues: {
      "ExportInvokePath": "C:\\Trendar\\POSBO\\BO2POS",
      "SourceTransactionsLogPath": "C:\\Trendar\\POSBO\\POS2BO",
      "MillisecondsToSleepBetweenRequests": 60000,
      "TotalNumberOfRequests": 60,
      "DaysToGoBack": 5,
      "DaysToKeepSentFiles": 90
    }
  },
  {
    id: 6,
    name: 'radiant',
    label: '6 - Radiant',
    defaultValues: {
      "source_path": "\\\\RSC-7STAR2\\ExportArchives",
      "daily_folders": true,
      "elevated_domain": "RSC-7STAR2",
      "elevated_username": "PDI",
      "elevated_password": "Radiant1",
      "days_to_keep": 31
    }
  }
]

